import { INITIAL_SAVE_REQUEST_META } from '../utils';
import { BrowseSettingsWidgetData } from './types';

const defaultBrowseSettingsWidgetData: NonNullable<BrowseSettingsWidgetData['initialData']> = {
  theatreView: 'zoomed_out',
  invisibleBrowsing: false,
  browseLimit: 0,
  browseLimitList: [],
  browsePagingMode: 'infinite',
};

export const defaultBrowseSettingsWidgetState: BrowseSettingsWidgetData = {
  initialData: defaultBrowseSettingsWidgetData,
  currentData: defaultBrowseSettingsWidgetData,
  isDirty: false,
  saveRequest: INITIAL_SAVE_REQUEST_META,
};
